export const componentArticleCardFragment = /* GraphQL */ `
  fragment componentArticleCard on ComponentArticleCard {
    sys {
      id
    }
    eyebrow(locale: $locale)
    title(locale: $locale)
    image {
      ...contentfulAsset
    }
    content(locale: $locale) {
      json
    }
    href(locale: $locale)
    textAlign(locale: $locale)
    containerSize(locale: $locale)
    containerMarginTop(locale: $locale)
    containerMarginBottom(locale: $locale)
  }
`
